export const stringKeys = {
  detailPanelTitle: 'CustomerListAudience_DetailPanel_FormGroup_Title',
  editAudienceStatement: 'CustomerListAudience_EditAudience_Statement',
  fileLoadingStatement: 'CustomerListAudience_FilePicker_FileLoading_Statement',
  fileUploadInstruction: 'CustomerListAudience_FileUpload_Instruction',
  fileUploadNotice: 'CustomerListAudience_FileUpload_Notice',
  actionSelectorError: 'CustomerListAudience_ActionSelector_Error',
  fileError: 'CustomerListAudience_File_Error',
  consentOath: 'CustomerListAudience_Consent_Oath',
  consentStatement: 'CustomerListAudience_Consent_Statement',
  consentError: 'CustomerListAudience_Consent_Error',
  resultTableHeaderUpdate: 'CustomerListAudience_ResultTable_Header_Update',
  resultTableHeaderError: 'CustomerListAudience_ResultTable_Header_Error',
  applyChangesButton: 'CustomerListAudience_Button_ApplyChanges',
  downloadResultButton: 'CustomerListAudience_Button_DownloadResult',
  cancelButton: 'CustomerListAudience_Button_Cancel',
  doneButton: 'CustomerListAudience_Button_Done',
  resultTablePreviewTitle: 'CustomerListAudience_ResultTable_Title_Preview',
  resultTableSuccessTitle: 'CustomerListAudience_ResultTable_Title_Success',
  resultPanelSuccessDescriptionTitle: 'CustomerListAudience_ResultPanel_Success_DescriptionLine_Title',
  resultPanelSuccessDescriptionLine1: 'CustomerListAudience_ResultPanel_Success_DescriptionLine_1',
  resultPanelSuccessDescriptionLine2: 'CustomerListAudience_ResultPanel_Success_DescriptionLine_2',
  resultPanelSuccessDescriptionLine3: 'CustomerListAudience_ResultPanel_Success_DescriptionLine_3',
  resultPanelSuccessDescriptionLine4: 'CustomerListAudience_ResultPanel_Success_DescriptionLine_4',
  itemTemplate: 'CustomerListAudience_Item_Template',
  itemCustomerMatchPolicies: 'CustomerListAudience_Item_CustomerMatchPolicies',
  invalidFileErrorMessage: 'CustomerListAudience_Invalid_File_ErrorMessage',
  maxRowsExceedErrorMessage: 'CustomerListAudience_Max_Rows_Exceed_ErrorMessage',
  noHeaderErrorMessage: 'CustomerListAudience_No_Header_ErrorMessage',
};

export const actionOptions = {
  noop: {
    enum: 0,
    type: 'Add',
    descriptionStringKey: '',
  },
  append: {
    enum: 1,
    type: 'Add',
    descriptionStringKey: 'CustomerListAudience_ActionOption_Description_Append',
  },
  delete: {
    enum: 2,
    type: 'Remove',
    descriptionStringKey: 'CustomerListAudience_ActionOption_Description_Delete',
  },
  replace: {
    enum: 3,
    type: 'Replace',
    descriptionStringKey: 'CustomerListAudience_ActionOption_Description_Replace',
  },
};

export const hashOptions = {
  plainText: {
    isHashed: false,
    titleStringKey: 'CustomerListAudience_HashOption_PlainText_Title',
    descriptionStringKey: 'CustomerListAudience_HashOption_PlainText_Description',
  },
  hashed: {
    isHashed: true,
    titleStringKey: 'CustomerListAudience_HashOption_Hashed_Title',
    descriptionStringKey: 'CustomerListAudience_HashOption_Hashed_Description',
  },
};

export const panelStateOptions = {
  idle: {
  },
  validateFile: {
    isProgressBarVisible: true,
  },
  previewResult: {
    isResultTableVisible: true,
    isApplyChangesButtonVisible: true,
    isDownloadResultButtonVisible: true,
    isCancelButtonVisible: true,
  },
  uploadFile: {
    isProgressBarVisible: true,
  },
  success: {
    isResultTableVisible: true,
    isDoneButtonVisible: true,
  },
  error: {
    isUserErrorVisible: true,
    isCancelButtonVisible: true,
  },
};

export const progressStateOptions = {
  idle: {
    percentage: '0%',
    statementStringKey: 'CustomerListAudience_ProgressBar_Statement_Idle',
  },
  validateRows: {
    percentage: '20%',
    statementStringKey: 'CustomerListAudience_ProgressBar_Statement_ValidateRows',
  },
  generateResultFile: {
    percentage: '80%',
    statementStringKey: 'CustomerListAudience_ProgressBar_Statement_GenerateResultFile',
  },
  generateUploadFile: {
    percentage: '10%',
    statementStringKey: 'CustomerListAudience_ProgressBar_Statement_GenerateUploadFile',
  },
  uploadFile: {
    percentage: '50%',
    statementStringKey: 'CustomerListAudience_ProgressBar_Statement_UploadFile',
  },
  createAudience: {
    percentage: '90%',
    statementStringKey: 'CustomerListAudience_ProgressBar_Statement_CreateAudience',
  },
  finished: {
    percentage: '100%',
    statementStringKey: 'CustomerListAudience_ProgressBar_Statement_Finished',
  },
};

export const uploadFileType = 'CustomerMatchFile';

export const fileTemplateLink = 'CustomerMatch/Customer_Match_Upload_Template.csv';
export const fileHashedTemplateLink = 'CustomerMatch/Customer_Match_Upload_Hashed_Template.csv';

export const customerMatchTermsEnglishVersionLink = 'https://go.microsoft.com/fwlink/?linkid=2106709';
export const customerMatchTermsFrenchVersionLink = 'https://go.microsoft.com/fwlink/?linkid=2108913';
export const customerMatchTermsLink = 'https://MicrosoftAdvertising.com/customer-match-terms';

export const microsoftAdvertisingAgreementLink = 'https://about.ads.microsoft.com/en-us/resources/policies/microsoft-advertising-agreement';
export const microsoftAdvertisingPolicyLink = 'https://about.ads.microsoft.com/en-us/resources/policies';

export const learnMoreLinkIds = {
  customerMatchAudience: 'app54675',
  customerList: 'app54675',
};
